export enum ButtonColor {
    NONE = '',
    PRIMARY = 'primary',
    ACCENT = 'accent',
    WARN = 'warn'
}
